module.exports = __webpack_public_path__ + "img/slolution-6.4d573f7.png";